import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';
import { useEditShareModal } from '../context/EditShareModalContext';

const EditShareModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useEditShareModal();

  return (
    <Modal.Header>
      <h5 className="mb-0">{t('EditShare')}</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default EditShareModalHeader;
